export const ServerConfig = {
	host: process.env.VUE_APP_AUTH_HOST as string,
	hostSocket: process.env.VUE_APP_AUTH_SOCKET as string,
	mainAppHost: process.env.VUE_APP_MAIN_APP_HOST as string,
	mainAppSocket: process.env.VUE_APP_MAIN_APP_SOCKET as string,
	mainAppUrl: process.env.VUE_APP_MAIN_APP_URL as string,
	defaultTestingDbId: process.env.VUE_APP_DEFAULT_TESTING_DB_ID ? parseInt(process.env.VUE_APP_DEFAULT_TESTING_DB_ID) : null as null | number
};
